import React from 'react';

export const WhatsappWhiteSM = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={23.874}>
    <defs>
      <clipPath id="a">
        <path fill="none" stroke="#004f92" d="M0 0h24v23.874H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 163096">
      <g>
        <path
          fill="none"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth={2.2}
          d="M12.486 1.119A10.827 10.827 0 0 0 1.243 11.51a10.526 10.526 0 0 0 1.368 5.726l-.75 2.608-.75 2.606 2.636-.64 2.636-.64a10.488 10.488 0 0 0 5.255 1.583 10.827 10.827 0 0 0 .848-21.637Z"
          data-name="Path 17075"
        />
        <path
          fill="#fff"
          d="M17.869 14.845c-.072-.122-.266-.194-.558-.34s-1.721-.849-1.988-.946-.46-.146-.654.146-.752.946-.922 1.141-.34.218-.63.072a7.937 7.937 0 0 1-2.34-1.444 8.735 8.735 0 0 1-1.618-2.016c-.169-.291-.018-.448.127-.594.131-.13.291-.34.437-.51a1.921 1.921 0 0 0 .294-.484.535.535 0 0 0-.025-.51c-.073-.146-.654-1.577-.9-2.16-.236-.566-.476-.49-.654-.5l-.552-.009a1.066 1.066 0 0 0-.775.364 3.268 3.268 0 0 0-1.025 2.427 5.665 5.665 0 0 0 1.187 3.01 12.984 12.984 0 0 0 4.97 4.393 17.013 17.013 0 0 0 1.658.613 4.014 4.014 0 0 0 1.833.116 3 3 0 0 0 1.963-1.384 2.426 2.426 0 0 0 .169-1.384"
          data-name="Path 17076"
        />
      </g>
    </g>
  </svg>
);
